import * as yup from "yup";
import Toast from "helper/toast";

//////////////////// file sizes and formates ////////////////////
export const FILE_SIZE = 10_000_000; //10 meg
export const SUPPORTED_FORMATS = ["zip"];
//////////////////// constant validation message ////////////////////
function strings({ title = "فیلد", size = "۵ مگ" }) {
  return {
    required: "این فیلد حتما باید پر شود",
    notMatch: title + " نامعتبر است ",
    size: `سایز ${title} باید کمتر از ${size} باشد`,
    min: `${title} حداقل باید ${size} حرف باشد`,
    unSupported: `فرمت ${title} نامعتبر است`,
  };
}

/////////////////// convert empty stringToNull ///////////////////
function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === "string" && originalValue === "") {
    return null;
  }
  return value;
}

///////////////// Image validator ///////////////////
export function validateImg(file) {
  if (!(file.type.split("/")[0] === "image")) {
    return Toast({
      type: "custom-warn",
      title: `فرمت عکس نامعبتر است`,
      autoClose: 3000,
    });
  } else if (file.size > FILE_SIZE) {
    return Toast({
      type: "custom-warn",
      //converting kb to megabyte
      title: `حجم عکس باید کمتر از ${FILE_SIZE / 1_000_000}  مگ باشد`,
      autoClose: 3000,
    });
  }
}

export function validateFile(file, title, limit, ...file_format) {
  if (!file) return false;
  const file_type = /[^.]+$/.exec(file.name)[0];
  const format = file_format[0].find((item) => item === file_type);

  if (!file_type || !format) {
    Toast({
      type: "custom-warn",
      title: `فرمت فایل ${title} نامعبتر است. (${file_format.join()})`,
      autoClose: 4000,
    });
    return false;
  }
  if (file && file.size > limit) {
    Toast({
      type: "custom-warn",
      title: `حجم فایل ${title} باید کمتر از ${limit / 1_000_000}  مگ باشد`,
      autoClose: 4000,
    });
    return false;
  }
  return true;
}

///////////////// login validator ///////////////////
export const loginSchema = yup
  .object({
    username: yup.string().required(strings("").required),
    pass: yup
      .string()
      .min(6, "حداقل 6 نویسه اجباری میباشد")
      .required(strings("").required),
  })
  .required();

///////////////// get otp code validator ///////////////////
export const getOtpCodeSchema = yup
  .object({
    username: yup.string().required(strings("").required),
  })
  .required();

///////////////// reset password validator ///////////////////
export const resetPasswordSchema = yup
  .object({
    otpCode: yup.string().required(strings("").required),
    password: yup.string().min(6, "حداقل 6 نویسه اجباری میباشد"),
    confirm_password: yup
      .string()
      .oneOf(
        [yup.ref("password"), null],
        strings({ title: "تکرار کلمه عبور" }).notMatch
      )
      .min(6, "حداقل 6 نویسه اجباری میباشد"),
  })
  .required();

///////////////// change password validator ///////////////////
export const changePasswordSchema = yup
  .object({
    current_password: yup.string().min(6, "حداقل 6 نویسه اجباری میباشد"),
    password: yup.string().min(6, "حداقل 6 نویسه اجباری میباشد"),
    confirm_password: yup
      .string()
      .oneOf(
        [yup.ref("password"), null],
        strings({ title: "تکرار کلمه عبور" }).notMatch
      )
      .min(6, "حداقل 6 نویسه اجباری میباشد"),
  })
  .required();

///////////////// Teacher Upload File Validator ///////////////////
export const teacherUploadFileSchema = yup
  .object({
    title: yup.string().required(strings("").required),
  })
  .required();

////////////////// attendance validation ///////////////////
export const attendanceSchema = yup
  .object({
    date: yup.string().required(strings("").required),
  })
  .required();

////////////////// add score validation ///////////////////
export const AddScoreSchema = yup
  .object({
    date: yup.string().required(strings("").required),
  })
  .required();

////////////////// add message validation ///////////////////
export const messageSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    text: yup.string().required(strings("").required),
  })
  .required();

////////////////// add score excell file ///////////////////
export const excellSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    date: yup.string().required(strings("").required),
    description: yup.string().required(strings("").required),
  })
  .required();
